namespace $ {

	export class $shm_hitalama_team_maps extends $giper_baza_list_link.to( ()=> $shm_hitalama_map ) {}

}
